/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';

const Select = ({
  name,
  value,
  onChange,
  children,
  caption,
  columnWidth,
  className,
  inputRef,
  wrapperStyle,
}) => {
  const colWidth = `col-md-${columnWidth}`;
  return (
    <div className={colWidth} style={wrapperStyle}>
      <div className="form-group">
        <label className="control-label" htmlFor={name}>
          {caption}
        </label>
        <select
          title={caption}
          onChange={onChange}
          value={value}
          name={name}
          className={`form-control ${className}`}
          ref={inputRef}
        >
          {children}
        </select>
      </div>
    </div>
  );
};

Select.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  caption: PropTypes.string,
  columnWidth: PropTypes.number.isRequired,
  inputRef: PropTypes.objectOf(PropTypes.object),
  className: PropTypes.string,
  // Inline style merged onto the col-md-X wrapper. Use this when you need
  // to show/hide the field without unmounting it (e.g. select2 bindings
  // must persist across visibility toggles).
  wrapperStyle: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
};

Select.defaultProps = {
  caption: '',
  inputRef: null,
  className: '',
  name: '',
  wrapperStyle: undefined,
};

export default Select;
